import axios from 'axios';
import React from 'react';
import { Modal } from 'react-bootstrap';
import { Field, formValueSelector, reduxForm, SubmissionError } from 'redux-form';
import { RenderHTMLSelect, RenderInputWithDiv, RenderNumberInput } from '../../../component/formInput';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';

const selector = formValueSelector("SdnsConfigModal");

class SdnsConfigModal extends React.Component {

  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
  }

  submit(values) {
    const { onHide, user_product_id, user_product_obj } = this.props;
    // Gán user_product_id.
    values.user_product_id = user_product_id;
    values.domain_id = user_product_obj.domain;
    let url = null;
    if(!values.id) {
      url = '/api/user/service/dns/create/record';
    }else {
      url = '/api/user/service/dns/update/record';
    }
    return axios({
      method: 'post',
      url: window.api_url + url,
      withCredentials: true,
      data: values
    }).then(function (response) {
      if (!response.data.isError) {
        toast.success("Cập nhật Record thành công !")
        onHide();
      } else {
        throw new SubmissionError(response.data.error)
      }
    }); 
  }
  

  handleHideModal = () => {
    const { onHide, reset } = this.props;
    reset();
    onHide();
  }

  render() {
    const { title, submitting, handleSubmit, userProduct, type_selected } = this.props;
    const modalConfig = { enforceFocus: false, backdrop: 'static', show: this.props.show, bssize: "medium", onHide: this.props.onHide, submitting: this.props.submitting };
    const type_options = [
      { label: "A", value: "A" },
      { label: "URL_REDIRECT", value: "URL_REDIRECT" },
      { label: "CNAME", value: "CNAME" },
      { label: "TXT", value: "TXT" },
      { label: "MX", value: "MX" },
      { label: "SRV", value: "SRV" },
    ]
    return <Modal
      bsPrefix = "modal"
      {...modalConfig}
      dialogClassName="modal-open">
        <ToastContainer />
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-sm">{title}</Modal.Title>
        </Modal.Header>
        <form onSubmit={handleSubmit(this.submit)}>
          <Modal.Body>
            <Field label="Name" name="name" placeholder="Input name..." component={RenderInputWithDiv}></Field>
            <Field label="Type" name="type" defaultValue={"A"}  options={type_options} component={RenderHTMLSelect}></Field>
            <Field label="Content" name="content" placeholder="Input content..." component={RenderInputWithDiv}></Field>
            {["MX","SRV"].includes(type_selected) && <Field label="Priority" defaultValue={type_selected == "MX" ? 10 : null}  name="prio" placeholder="" component={RenderNumberInput}></Field>}
            {type_selected == "SRV" && <React.Fragment>
              <Field label="Weight" defaultValue={0} name="weight" placeholder="" component={RenderNumberInput}></Field>
              <Field label="Port" defaultValue={0} name="port" placeholder="" component={RenderNumberInput}></Field>
            </React.Fragment>}
          </Modal.Body>
          
          <Modal.Footer>
            <div className="text-right">
              <a className="btn" onClick={this.handleHideModal}>Đóng</a>
              <button type="submit" className="btn bg-primary" disabled={submitting}>Lưu</button>
            </div>
          </Modal.Footer>
        </form>
      </Modal>
  }
}
const mapState = (state,props) => ({
  initialValues: props.record_obj,
  type_selected: selector(state, "type")
});

const mapDispatch = dispatch => ({
  
});

export default (connect(mapState, mapDispatch)(
  reduxForm({
    form: 'SdnsConfigModal',
    destroyOnUnmount: true,
    enableReinitialize: true
})(withRouter(SdnsConfigModal))));
